import { format } from "fecha";

import { getNews } from "../../api/news/get";
import hx from "../../utils/hydroxie";
import { parseNewsText } from "../../utils/parsenewstext";
import { pickElement as $ } from "../../utils/pickelements";

(async () => {
    try {
        const news = await getNews();
        const elems = news
            .map((x) => {
                return hx("div", { className: "box" },
                    hx("p", format(new Date(x.date), "YYYY-MM-DD")),
                    hx("div", parseNewsText(x.text)));
            });
        $("#app").replaceChildren(...elems);
    } catch (e) {
        console.error(e);
        alert((Error.isError(e)) ? e.message : e);
    }
})();
